import {createStyles, Theme} from "@material-ui/core";
import {beigeColor} from "src/main.style";

export const FullScreenCardStyle = (theme: Theme) =>
    createStyles({
        signupCard: {
            flex: 1,
            flexGrow: 1,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            fontFamily: 'Metropolis',
            justifyContent: 'flex-end',
            zIndex: 2,
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'center',
                alignItems: 'center',
            },
        },
        loginLogo: {
            width: '200px',
            height: 'auto',
        },
        signCardContent: {
            display: 'flex',
            width: '100%',
        },
        signupPage: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            minHeight: '100vh',
            maxHeight: '100vh',
            overflowY: 'auto',
            backgroundColor: theme.palette.background.default,
        },
        logoContainer: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '30px',
                minWidth: '50%',
                gap: '30px',

            },
        },
        background: {
            backgroundColor: beigeColor,
            width: '100%',
            height: '100%',
            position: 'absolute',
            clipPath: 'none',
            zIndex: 1,
            [theme.breakpoints.up('md')]: {
                clipPath: 'circle(800px at calc(50% - 800px) 50%)',
            },
        },
        logoText: {
            fontSize: '20px',
        },
        signupSpacer: {
            height: '0px',
            [theme.breakpoints.up('sm')]: {
                height: '30px',
            },
            [theme.breakpoints.up('md')]: {
                height: '100px',
            },
        },
        signupTypoPadding: {
            padding: '24px 0',
        },
        signupInviteLink: {
            padding: '16px 0',
        },
    });



// WEBPACK FOOTER //
// ./src/components/common/fullscreencard/FullScreenCard.style.ts